import produce from 'immer'
import { types } from './actions'

function LifecycleEvent({ event, data }) {
    this.event = event
    this.data = data
}

export const initialState = {
    events: [],
}

const reducer = (state = initialState, { type, payload }) => produce(state, (draftState) => {
    switch (type) {
        case types.ADD_EVENT:
            draftState.events.push(
                {
                    ...(new LifecycleEvent(payload)),
                },
            )
            break
        default:
            break
    }

    return draftState
})

export default reducer
